module.exports = "<app-usuaris></app-usuaris>"